import { clsx } from 'clsx';

import { ID_PRODUCT_VIDEO_ATTRIBUTE } from '@shared/constants/keys';
import { useAppSelector } from '@shared/hooks/redux';

import { Caption } from '../Caption/Caption';
import { EmptyState } from '../EmptyState/EmptyState';
import cls from './Video.module.scss';

export const Video = () => {
  const props = useAppSelector((state) => state.product.data.props);
  const videos = props[ID_PRODUCT_VIDEO_ATTRIBUTE]?.values;

  if (!videos?.length) {
    return <EmptyState />;
  }

  return (
    <div className={cls.wrap}>
      <Caption>Видео</Caption>
      <div className={clsx(cls.videoWrap, { [cls.flex]: videos.length === 1 })}>
        {videos.map(({ value }, i) => (
          <iframe
            key={value + i}
            className={cls.iframe}
            src={value}
            allowFullScreen
          />
        ))}
      </div>
    </div>
  );
};
